// extracted by mini-css-extract-plugin
export default {"editor":"plan-editor_editor__qTN68","formContainer":"plan-editor_formContainer__H6Bp2"};